import React from "react";
import ReactDOM from "react-dom/client";

import axios from "axios";
import { PublicClientApplication, EventType } from "@azure/msal-browser";

import { getEnv } from "./environment";

import App from "./App";

import "./index.css";
import { MsalProvider } from "@azure/msal-react";

const env = getEnv();
axios.defaults.baseURL = env.url;

export const pca = new PublicClientApplication({
  auth: {
    clientId: env.auth_client_id,
    authority: env.authority,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
});

// Default to using the first account if no account is active on page load
if (!pca.getActiveAccount() && pca.getAllAccounts().length > 0) {
  pca.setActiveAccount(pca.getAllAccounts()[0]);
}

// Update account state if a user signs in from another tab or window
pca.enableAccountStorageEvents();

pca.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    pca.setActiveAccount(account);
  }
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <MsalProvider instance={pca}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
